import { render, staticRenderFns } from "./ExamAbsentPage.vue?vue&type=template&id=2452d24a&scoped=true&"
import script from "./ExamAbsentPage.vue?vue&type=script&lang=js&"
export * from "./ExamAbsentPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamAbsentPage.vue?vue&type=style&index=0&id=2452d24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452d24a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
